import { MODALS_URL } from '@skeleton/consts/modals';

const MODALS_URL_KEYS = new Set(Object.values(MODALS_URL));

function isModalQueryChanged(newQuery: Record<string, any>, oldQuery: Record<string, any>): boolean {
  const queryKeys = Object.keys(newQuery);
  const oldQueryKeys = Object.keys(oldQuery);

  const addedKeys = queryKeys.filter(key => !oldQueryKeys.includes(key));
  const removedKeys = oldQueryKeys.filter(key => !queryKeys.includes(key));

  return addedKeys.some(key => MODALS_URL_KEYS.has(key)) || removedKeys.some(key => MODALS_URL_KEYS.has(key));
}

export { isModalQueryChanged };
